import { render, staticRenderFns } from "./list.vue?vue&type=template&id=5e0fdecf&scoped=true"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"
import style0 from "./list.vue?vue&type=style&index=0&id=5e0fdecf&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e0fdecf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/actions-runner/_work/treasurenet-tnservices-servicesplatform-fe/treasurenet-tnservices-servicesplatform-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e0fdecf')) {
      api.createRecord('5e0fdecf', component.options)
    } else {
      api.reload('5e0fdecf', component.options)
    }
    module.hot.accept("./list.vue?vue&type=template&id=5e0fdecf&scoped=true", function () {
      api.rerender('5e0fdecf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/stake/boosting/list.vue"
export default component.exports